export var StorageKey;
(function (StorageKey) {
    StorageKey["AUTH_TOKEN"] = "piabAuthToken";
})(StorageKey || (StorageKey = {}));
